import { Button, ButtonProps } from 'antd';

const ZeissButton = (props: ButtonProps): any => {
  const { className, ...reset } = props;
  return <Button className={`${className ?? ''}`} {...reset} />;
};

export default ZeissButton;
